<ng-container *uiContentLoading="state.initialLoading$ | async">
    <div [class.search-mode]="!!state.searchValue"
         role="application">
        <div class="search-container">
            <mat-form-field floatLabel="never">
                <input #search
                       [uiAutofocus]
                       [formControl]="searchControl"
                       [selectionLocation]="'end'"
                       [placeholder]="'folder_search' | translate"
                       matInput
                       autocomplete="off"
                       type="text">

                <button (click)="onSearchClearClicked()"
                        mat-icon-button
                        matSuffix
                        type="button"
                        title="{{'folder_tree_clear_search' | translate }}"
                        class="ui-folder-search-clear">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div #treeContainer
             *ngLet="state.containers$ | async as containers"
             [attr.aria-label]="'folder_tree' | translate"
             (keydown)="navigate($event.key)"
             (keydown.enter)="selectFolder(highlighted)"
             tabindex="0"
             class="ui-folder-tree">
            <ng-container *uiContentLoading="state.searching$ | async">
                <cdk-virtual-scroll-viewport (rangeLoad)="state.rangeLoad($event)"
                                             uiVirtualScrollRangeLoader
                                             itemSize="{{state.isInSearchMode ? 55 : 40}}"
                                             class="ui-folder-tree-viewport">
                    <ng-container *cdkVirtualFor="let folder of containers; let i = index; trackBy: trackById;">
                        <div *ngLet="(context === 'switch' && !folder.folderData?.isSelectable) as disabled"
                             [class.ui-folder-tree-item-container-highlighted]="highlighted && highlighted?.id === folder.folderData?.id"
                             [class.ui-folder-tree-item-container-not-selectable]="disabled"
                             [attr.data-cy]="'folder-' + folder.folderData?.id"
                             [matRippleDisabled]="disabled"
                             (click)="selectFolder(folder.folderData)"
                             class="ui-folder-tree-item-container"
                             matRipple>
                            <div *ngLet="state.loadingFolder$.value.value && state.loadingFolder$.value.id === folder.folderData?.id as isItemLoading"
                                 [style.paddingLeft.px]="(folder.folderData?.level - 1) * 40"
                                 [class.ui-folder-tree-item-no-children]="!folder.folderData?.hasChildren"
                                 [class.ui-folder-tree-item-lg]="state.isInSearchMode"
                                 class="ui-folder-tree-item">

                                <button *ngIf="!!folder.folderData?.hasChildren"
                                        [disabled]="state.loadingFolder$.value.value"
                                        [spinnerButtonLoading]="isItemLoading"
                                        (click)="state.toggleExpand(folder.folderData, i, $event)"
                                        (mousedown)="$event.stopPropagation()"
                                        mat-icon-button
                                        ui-spinner-button
                                        tabindex="-1"
                                        class="ui-folder-tree-item-expand-btn"
                                        type="button">
                                    <mat-icon>
                                        {{ state.isExpanded(folder.folderData?.id) ? 'expand_more' : 'chevron_right' }}
                                    </mat-icon>
                                </button>

                                <span *ngLet="folder.folderData?.id === state.selectedFolderId as isFolderSelected"
                                      [matTooltip]="context === 'switch' && !folder.folderData?.isSelectable ? ('you_are_not_added_to_folder' | translate): ''"
                                      [class.ui-folder-tree-item-details-selected]="isFolderSelected"
                                      [class.ui-folder-tree-item-details-not-selectable]="context === 'switch' && !folder.folderData?.isSelectable"
                                      class="ui-folder-tree-item-details">
                                    <mat-icon *ngIf="folder.folderData"
                                              [class.ui-folder-icon-modern]="folder.folderData.type === FolderType.Modern"
                                              [class.ui-folder-icon-classic]="folder.folderData.type === FolderType.Classic"
                                              class="ui-folder-icon">folder_{{isFolderSelected ? 'shared' : 'open'}}
                                    </mat-icon>
                                    <span class="ui-folder-tree-item-details-text">
                                        {{folder.folderData?.displayName || 'folders_loading' | translate}}
                                        <span *ngIf="state.isInSearchMode && folder.folderData?.displayName !== folder.folderData?.fullyQualifiedName"
                                              class="ui-folder-tree-item-details-text-description">
                                            {{folder.folderData?.fullyQualifiedName}}
                                        </span>
                                    </span>
                                </span>

                            </div>
                        </div>
                    </ng-container>

                    <em *ngIf="!containers.length"
                        class="ui-folder-tree-no-folders"
                        translate>
                        folders_no_folders
                    </em>
                </cdk-virtual-scroll-viewport>
            </ng-container>
        </div>
    </div>
</ng-container>
